import './style.css';

const Logo = () => {
    return (
        <div className='logo-wrapper'>
            <h1 className='lilita-one'>Skrzeczek</h1>
        </div>
    );
}

export default Logo;